import { Get } from "../../../../Request";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
export const useClasses = () => {
  const [loading, setLoading] = useState(true);
  const [Data, setData] = useState({});
  const [filterDate, setFilterDate] = useState({});
  const getData = async pageNumber => {
    setLoading(true);
    Get({
      url: "/class/list",
      data: filterDate,
      page: pageNumber,
    }).then(res => {
      setData(res);
      setLoading(false);
    });
  };
  return { Data, loading, getData, setFilterDate, filterDate };
};

export const useSingleData = () => {
  const [loading, setLoading] = useState(true);
  const [Data, setData] = useState({});
  const getData = slug => {
    setLoading(true);
    Get({
      url: "/class/single",
      data: {
        slug,
      },
    }).then(res => {
      setLoading(false);
      setData(res);
    });
  };
  return { Data, loading, getData };
};

export const useOrder = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState({
    order: false,
    offer: false,
  });
  const [showList, setShowList] = useState([]);
  const [offer, setOffer] = useState({
    code: null,
    result: null,
    sendcode: false,
  });
  const [type_payment, settype_payment] = useState("gateway");
  const sendData = data => {
    Get({
      url: "/order/new_joinclass",
      data: data,
      stat: true,
    }).then(response => {
      setLoading({ ...loading, order: false });
      if (response.data) {
        if (type_payment === "wallet") {
          dispatch({
            local_storage: {
              key: "classData",
            },
            payload: "classData",
            type: "REMOVE",
          });
          if (data) {
            window.location.replace(response.data);
          }
        } else if (
          type_payment == "gateway" &&
          response.data &&
          response.data.url
        ) {
          dispatch({
            local_storage: {
              key: "classData",
            },
            payload: "classData",
            type: "REMOVE",
          });
          window.location.replace(response.data.url);
        }
      }
    });
  };
  const offercheck = async data => {
    return await Get({
      url: "/off/check",
      data: {
        ...data,
      },
      stat: true,
    }).then(data => {
      setLoading({
        ...loading,
        offer: false,
      });
      if (data != null) {
        setOffer({ ...offer, result: data.data, sendcode: true });
      }
    });
  };
  return {
    showList,
    setShowList,
    loading,
    offercheck,
    setLoading,
    offer,
    setOffer,
    sendData,
    type_payment,
    settype_payment,
  };
};
export const useSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingSearch, setLoadingSearch] = useState(true);

  const dispatch = useDispatch();

  const searchHandler = (data, pageNumber = 1, limit) => {
    setLoading(true);
    const page = data.page || 1;
    Get({
      url: "/class/list",
      page: page,
      data: data,
    }).then(result => {
      setState(result);
      setLoading(false);
    });
  };

  const getCategory = async () => {
    setLoadingSearch(true);
    await Get({
      url: "/category/show_all",
      data: {},
    }).then(data => {
      dispatch({
        type: "SET",
        payload: {
          categories: data,
          cities: [
            {
              name: "تهران",
              id: 329,
            },
            {
              name: "مشهد",
              id: 491,
            },
            {
              name: "شاهرود",
              id: 634,
            },

            {
              name: "سمنان",
              id: 630,
            },
            {
              name: "نیشابور",
              id: 502,
            },
          ],
        },
      });

      setLoadingSearch(false);
    });
  };
  const search = {
    tag: searchParams.get("tag"),
    item_gender: searchParams.get("item_gender"),
    city_id: searchParams.get("city_id"),
    title: searchParams.get("title"),
    category_id: searchParams.get("category_id"),
    sort: searchParams.get("sort"),
    page: searchParams.get("page") || 1,
    name: searchParams.get("name"),
  };
  const handleFilter = (key, value) => {
    let newSearch = {};
    Object.keys(search).map(key => {
      if (search[key]) {
        newSearch[key] = search[key];
      }
    });
    setSearchParams({ ...newSearch, [key]: value });
    searchHandler(
      {
        tag: searchParams.get("tag"),
        item_gender: searchParams.get("item_gender"),
        city_id: searchParams.get("city_id"),
        title: searchParams.get("title"),
        category_id: searchParams.get("category_id"),
        sort: searchParams.get("sort"),
        name: searchParams.get("name"),
        page: searchParams.get("page") || 1,
        [key]: value,
      },
      search.page,
      15
    );
  };
  const getValue = key => {
    if (key) {
      return search[key];
    }
    return false;
  };
  const clearFilters = () => {
    setSearchParams({});
    searchHandler({}, 1, 15);
  };

  const filterDelete = ele => {
    let newSearch = {};
    Object.keys(search).map(key => {
      if (search[key]) {
        newSearch[key] = search[key];
      }
    });
    delete newSearch[ele];
    setSearchParams({ ...newSearch });
    searchHandler(
      {
        ...newSearch,
      },
      search.page,
      15
    );
  };

  return {
    loadingSearch,
    search,
    handleFilter,
    searchHandler,
    state,
    loading,
    getCategory,
    getValue,
    clearFilters,
    filterDelete,
  };
};

export const useFilter = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const getTags = async () => {
    setLoading(true);
    await Get({
      url: "/data/need",
      data: {
        needkey: ["usedTags"],
      },
    }).then(data => {
      dispatch({
        type: "SET",
        payload: { tags: data.usedTags },
      });
      setLoading(false);
    });
  };
  return {
    loading,
    getTags,
  };
};
